<div class="vault-page-shell" *ngIf="configService.searchConfigSubject | async as searchConfig">
  <div class="space-y-6" *ngIf="searchConfig.selectedBrand as selectedBrand">
    <a [routerLink]="'/search'" id="hsd-back" class="vault-back-link">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      Back to search
    </a>

    <div class="vault-page-header">
      <div class="space-y-3">
        <p class="vault-page-kicker">Connection details</p>
        <div class="space-y-2">
          <h1 id="hsd-name" class="vault-page-title">{{selectedBrand.name}}</h1>
          <p id="hsd-description" class="vault-page-copy max-w-2xl">Choose the portal that matches how you sign in to continue connecting this health system to your vault.</p>
        </div>
      </div>
    </div>
    <div class="vault-divider"></div>

    <section class="vault-panel p-6 sm:p-8">
      <div class="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
        <div class="flex items-start gap-4">
          <img class="h-14 w-14 rounded-lg border border-slate-200 bg-white object-contain p-2" imageFallback src="https://cdn.fastenhealth.com/logos/sources/{{selectedBrand.id}}.png">
          <div class="space-y-3">
            <div *ngIf="selectedBrand.brand_website" class="flex items-center gap-2 text-slate-500" id="hsd-website-container">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                <path d="M2 12h20" />
              </svg>
              <a id="hsd-website" class="text-sm font-medium text-[#5B47FB] hover:underline" [href]="selectedBrand.brand_website" target="_blank" rel="noopener noreferrer">
                {{selectedBrand.brand_website}}
              </a>
            </div>
            <div *ngIf="selectedBrand.locations" class="flex items-center gap-2 text-slate-500">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span id="hsd-location" class="text-sm">
                <span *ngFor="let stateCode of (selectedBrand.locations || []) | slice:0:3;">{{stateCode | stateName}}</span>
                <span *ngIf="(selectedBrand.locations || []).length > 4">+ {{(selectedBrand.locations || []).length}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="rounded-lg bg-slate-50 px-4 py-3 text-sm text-slate-500">
          {{(selectedBrand.portals || []).length}} sign-in option<span *ngIf="(selectedBrand.portals || []).length !== 1">s</span> available
        </div>
      </div>
    </section>

    <section class="vault-panel overflow-hidden" id="hsd-institutions-list">
      <div class="border-b border-slate-100 px-6 py-4">
        <h2 class="text-lg font-semibold text-slate-900">Available portals</h2>
      </div>
      <div class="space-y-2 p-3 sm:p-4">
        <ng-container *ngFor="let portal of selectedBrand.portals">
          <div *ngFor="let endpoint of portal.endpoints" class="rounded-lg border border-slate-200 bg-white p-4 transition-colors hover:border-slate-300">
            <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <div class="space-y-1">
                <h3 class="font-semibold tracking-tight text-slate-900">{{portal.name}}</h3>
                <p class="text-sm text-slate-500">Use this connection if it matches the portal you use with {{selectedBrand.name}}.</p>
              </div>
              <button (click)="addPendingAccount(selectedBrand, portal, endpoint)" type="button" class="vault-primary-button">
                Connect
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </section>
  </div>
</div>
